import { createContext } from 'react';

export interface WorkspaceState {
  mode: 'admin' | 'accounts';
  /** The workspace this tab is pinned to; null in admin mode. */
  workspaceId: string | null;
  /** Switches this tab to another workspace. */
  switchTo(id: string): Promise<void>;
}

export const WorkspaceContext = createContext<WorkspaceState>({
  mode: 'admin',
  workspaceId: null,
  switchTo: async () => {}
});
